import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["modal", "input", "trigger"]

  toggleModal() {
    event.stopPropagation();
    this.modalTarget.classList.toggle('is-active');
    let turbo_tag = $(this.element).parent('turbo-frame');
    if (turbo_tag.length > 0) {
      Turbo.renderStreamMessage(`<turbo-stream action="replace" target="${turbo_tag[0].id}" ><template><turbo-frame id="${turbo_tag[0].id}" ></turbo-frame></template></turbo-stream>`)
    }
  }

  open() {
    event.stopPropagation();
    this.modalTarget.classList.toggle('is-active');
  }

  close() {
    event.stopPropagation();
    if (this.modalTarget.classList.contains('is-active')) {
      if (this.modalTarget !== event.target && !this.modalTarget.contains(event.target)) {
        this.modalTarget.classList.remove('is-active');
      }
    }
  }

  emptyAlert() {
    alert('Atleast select one invoice.');
  }

  setFileName(e) {
    const fileName = e.target.value.split('\\').pop();
    if (this.inputTarget.nodeName == 'INPUT') {
      this.inputTarget.textContent = fileName;
    } else {
      this.inputTarget.innerHTML = fileName;
    }
  }

  switchTab() {
    let active_ele = document.querySelector('[data-behaviour="js-tabs"]').querySelector('.is-active');
    let yr_to_remove = active_ele.children[0].dataset.target
    document.querySelectorAll(`[data-content='${yr_to_remove}']`).forEach( (i) => {
      i.classList.add('is-hidden')
    })

    active_ele.classList.remove('is-active')
    document.querySelectorAll(`[data-content='${event.target.dataset.target}']`).forEach((i) => {
      i.classList.remove('is-hidden')
    })
    event.target.parentElement.classList.add('is-active')
  }

  openAndRender() {
    event.preventDefault()
    this.toggleModal()
    let href = event.target.getAttribute("href")
    let frame_id = "turbo-frame#" + event.target.getAttribute("data-turbo-frame")
    let frame = document.querySelector(frame_id)

    frame.src = href
    frame.reload()
  }
}

